"use strict";

import { Collection } from "Collection";
import { FormFilterFieldsModel } from 'Models/FormFilterFieldsModel';
import { Objects } from "Constants/objects";
export var FormFilterFieldsCollection = Collection.extend({
  model: FormFilterFieldsModel,
  object: Objects.SysFormFilterFields
});